import { useRef, useState, useContext, useEffect } from 'react'
import { AuthContext } from './Authentication';
import { APIsHandlerContext } from './APIs';
import { ShapeContext } from './Shapefile';

function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }

export default function MapsManager({ funcao, device, AbrirMapa, limparEventoEscolhido, limparCampoEscolhido, limparVeiculoEscolhido }) {
    const ref = useRef(null);
    const { uploadFile, downloadFile, readShapefiles, getAuthUser, deleteShapefile } = useContext(AuthContext);
    const { newShapefileAPIPost, getDeviceMaps, removeShapefileAPI } = useContext(APIsHandlerContext);
    const { importShp } = useContext(ShapeContext);
    const [ nivelPermissao, setNivelPermissao ] = useState(false);
    const [ progress, setProgress ] = useState();
    const [ shapefiles, setShapeFiles ] = useState();
    let shxBinary;
    let shpBinary;
    let dbfBinary;
    const [user, setUser] = useState();

    useEffect(() => {
      getShapeFiles();
    }, []);

    function getShapeFiles () {
      getAuthUser().then(authUserResp => {
        if (authUserResp === null) {
          console.log("Não tem usuario logado resp = ", authUserResp);
          return;
        }
        else {
          setUser(authUserResp);
          console.log("OK usuario ", authUserResp.attributes.email, " logado, pedindo do device = ", device.deviceID);
          getDeviceMaps(authUserResp.attributes.sub, device.deviceID)
          .then(res => {
            if(!res.ok) throw Error("Não conseguiu buscar");
            return res.json();
          })    
          .then(data => {
            setShapeFiles(data);
            console.log("getDeviceMaps = ", data);
          })
          .catch(err => {
            console.log(`erro ${err}`);
          });
        }
      });      
    }    

    const handleFileLoad = () => {
        console.log("Files = ", ref.current.files);
        //verifica os nomes        
        if (ref.current.files.length < 3) {
            console.log("Faltando arquivos");
            return;
        }
        const nome1 = ref.current.files[0].name.split(".");
        console.log("nome 1 é do tipo = ", typeof(nome1));
        const nome2 = ref.current.files[1].name.split(".");
        const nome3 = ref.current.files[2].name.split(".");
        
        let temDbf;
        let temShx;
        let temShp;
        if ((nome1[0] === nome2[0]) && (nome1[0] === nome3[0])) {
            console.log("nomes batem");
            if ((nome1[1] === 'dbf') || (nome2[1] === 'dbf') || (nome3[1] === 'dbf')) {
                temDbf = true;
            }
            if ((nome1[1] === 'shx') || (nome2[1] === 'shx') || (nome3[1] === 'shx')) {
                temShx = true;
            }
            if ((nome1[1] === 'shp') || (nome2[1] === 'shp') || (nome3[1] === 'shp')) {
                temShp= true;
            }
            if (!temDbf) {
                console.log("falta dbf");
            } else if (!temShx) {
                console.log("falta shx");
            } else if (!temShp) {
                console.log("falta shp");
            } else {
              console.log("Tudo certo");
              const shapefileUUID = uuidv4();
              getAuthUser().then(authUserResp => {
                if (authUserResp === null) {
                  console.log("Não tem usuario logado resp = ", authUserResp);
                  return;
                }
                else {
                  console.log("OK usuario ", authUserResp.attributes.sub, " logado"); //authUserResp.attributes.email
                  //OK Fazer upload
                  uploadFile(shapefileUUID + '.' + nome1[1], ref.current.files[0])
                  .then((resp) => {
                    console.log("resp=", resp);
                    uploadFile(shapefileUUID + '.' + nome2[1], ref.current.files[1])
                    .then((resp) => {
                      console.log("resp=", resp);
                      uploadFile(shapefileUUID + '.' + nome3[1], ref.current.files[2])
                      .then((resp) => {
                        console.log("resp=", resp);
                        //se deu certo o upload dos 3 arquivos, insere no DB
                        let idsAcesso = "";
                        if (!nivelPermissao)
                          idsAcesso = device.deviceID;
                        newShapefileAPIPost(authUserResp.attributes.sub, shapefileUUID, idsAcesso, nome1[0])
                        .then((resp) => {
                          console.log("resp da API de newshapefile", resp);
                          getShapeFiles();
                        });
                      });
                    });
                  });
                }
              });
            }
        } else {
            console.log("arquivos com nomes diferentes");
        }
    };

  const handleGetFile = (fileKey, filename) => {
    downloadFile(fileKey + ".dbf", filename + ".dbf")
    .then((data) => {
      downloadFile(fileKey + ".shp", filename + ".shp")
      .then((data) => {
        downloadFile(fileKey + ".shx", filename + ".shx")
        .catch(err => console.log(err));
      })
      .catch(err => console.log(err));
    })
    .catch(err => console.log(err));
  }

  const handleViewMap = (fileKey) => {
    limparEventoEscolhido(null);
    limparCampoEscolhido(null);
    limparVeiculoEscolhido(null);
    readShapefiles(fileKey + ".shp")
    .then((signedURL) => {
      const url = URL.createObjectURL(signedURL.Body);
      //const a = document.createElement('a');
      //a.href = url;
      fetch(url)
      .then((response) => response.arrayBuffer())
      .then(data => {
        //console.log("data agora e ", data);
        shpBinary = data;
        console.log("shpBinary = ", shpBinary);
        readShapefiles(fileKey + ".shx")
        .then((signedURL) => {
          const url = URL.createObjectURL(signedURL.Body);
          //const a = document.createElement('a');
          //a.href = url;
          fetch(url)
          .then((response) => response.arrayBuffer())
          .then(data => {
            shxBinary = data;
            console.log("shxData = ", shxBinary);
            readShapefiles(fileKey + ".dbf")
            .then((signedURL) => {
              const url = URL.createObjectURL(signedURL.Body);
              fetch(url)
              .then((response) => response.arrayBuffer())
              .then(data => {
                dbfBinary = data;
                console.log("dbfData = ", dbfBinary);
                importShp(shpBinary, shxBinary, dbfBinary);
                AbrirMapa();
              });
            });
          });
          //console.log("handleViewMap data = ", data);
        });
      })
      //console.log("handleViewMap data = ", data);
    })
    
  }

  const handleDelete = (fileKey) => {
    removeShapefileAPI(user.attributes.sub, fileKey)
    .then(res => {
      if(!res.ok) throw Error("Não conseguiu buscar");
      return res.json();
    })
    .then((data2) => {
      console.log("data2 = ", data2);
      if (data2.errorMessage === undefined) {
        console.log("Não deu erro");
        deleteShapefile(fileKey + ".dbf")
        .then((data) => {
          console.log("delete .dbf = ", data);
          deleteShapefile(fileKey + ".shp")
          .then((data) => {
            console.log("delete .shp = ", data);
            deleteShapefile(fileKey + ".shx")
            .then((data) => {
              console.log("delete .shx = ", data);
              getShapeFiles();          
            });
          });
        });
      } 
      else {
        console.log("Deu erro", data2.errorMessage)
      }
    });
  }

  return (
    <div>
        <button onClick={() => funcao(1)}>Voltar</button>
        <header className="AppHeader">
            <h2>MapsManager</h2>
            <table>
            <thead>
                <tr>
                <td></td>
                <td>Mapa</td>
                <td>Permissão</td>
                </tr>
            </thead>
            <tbody>
                {shapefiles && shapefiles.map((file,i) => (
                <tr key={file.shapefileUUID}>
                    <td>{i+1}</td>
                    <td>{file.filename}</td>
                    <td>{file.deviceID === "" ? 'todos': 'apenas'}</td>
                    <td>
                        <button onClick={() => handleGetFile(file.shapefileUUID, file.filename)}>FazerDownload</button>
                        <button onClick={() => handleDelete(file.shapefileUUID)}>Excluir</button>
                        <button onClick={() => handleViewMap(file.shapefileUUID)}>Visualizar</button>
                    </td>
                </tr>
                ))}
                <tr>
                <td>Novo Mapa</td>
                <td><input ref={ref} type="file" multiple='multiple' onChange={handleFileLoad} /></td>
                <td>
                    <label>permissão:</label>
                    <select
                    value={nivelPermissao}
                    onChange={(e) => setNivelPermissao(e.target.value)}
                    >
                    <option value={false}>Apenas para este</option>
                    <option value={true}>Para todos</option>
                    </select>
                </td>
                </tr>
            </tbody>
            </table>        
            { progress }
        </header>
    </div>
  )
}
